import {
  ResearchAcquisitionPathEnum,
  ResearchClientProgressStatusEnum,
  ResearchIntakeExclusionDispositionEnum,
  ResearchStageEnum,
  ResearchWorkTypeEnum,
} from "./types";

export const RESEARCH_SLICE_NAME = "research";

export const RESEARCH_STAGE_LABELS: Record<ResearchStageEnum, string> = {
  [ResearchStageEnum.INTAKE_QUEUE]: "Intake Queue",
  [ResearchStageEnum.ABOVE_BOARD_CONVERSATION]: "Above Board Conversation",
  [ResearchStageEnum.SHOP_QUEUE]: "Shop Queue",
  [ResearchStageEnum.SHOP_IN_PROCESS]: "Shop In Process",
  [ResearchStageEnum.RETRY_QUEUE]: "Retry Queue",
  [ResearchStageEnum.RETRY_IN_PROCESS]: "Retry In Process",
  [ResearchStageEnum.READY_FOR_REVIEW]: "Ready for Review",
  [ResearchStageEnum.REQUIRES_FIX]: "Requires Fix",
  [ResearchStageEnum.COMPLETED]: "Completed",
};

export const RESEARCH_STAGE_SHORT_LABELS: Record<ResearchStageEnum, string> = {
  ...RESEARCH_STAGE_LABELS,
  [ResearchStageEnum.ABOVE_BOARD_CONVERSATION]: "Above Board",
  [ResearchStageEnum.SHOP_IN_PROCESS]: "1st Shop",
  [ResearchStageEnum.RETRY_IN_PROCESS]: "2nd Shop",
  [ResearchStageEnum.READY_FOR_REVIEW]: "Review",
  [ResearchStageEnum.COMPLETED]: "Complete",
};

export const RESEARCH_STAGE_ORDER = Object.values(ResearchStageEnum);

export const RESEARCH_WORK_TYPE_LABELS: Record<ResearchWorkTypeEnum, string> = {
  [ResearchWorkTypeEnum.TIME_SENSITIVE_REQUEST]: "ASAP",
  [ResearchWorkTypeEnum.SCHEDULED_SHOP_ROUND]: "Scheduled Shops",
};

export const RESEARCH_ACQUISITION_PATH_LABELS: Record<
  ResearchAcquisitionPathEnum,
  string
> = {
  [ResearchAcquisitionPathEnum.ABOVE_BOARD]: "Above Board",
  [ResearchAcquisitionPathEnum.ABOVE_BOARD_AND_1_SHOP]:
    "Above Board and 1 Shop",
  [ResearchAcquisitionPathEnum.ABOVE_BOARD_AND_2_SHOPS]:
    "Above Board and 2 Shops",
};

export const RESEARCH_INTAKE_EXCLUSION_LABELS: Record<
  ResearchIntakeExclusionDispositionEnum,
  string
> = {
  [ResearchIntakeExclusionDispositionEnum.CURRENT_SUBJECT]:
    "Excluded because it is a Subject in this request.",
  [ResearchIntakeExclusionDispositionEnum.KNOWN_CLIENT_SUBJECT]:
    "Excluded because it is already a Subject for another Client.",
};

export const RESEARCH_PROGRESS_STATUS_LABELS: Record<
  ResearchClientProgressStatusEnum,
  string
> = {
  [ResearchClientProgressStatusEnum.ON_TRACK]: "On track",
  [ResearchClientProgressStatusEnum.AT_RISK]: "At risk",
  [ResearchClientProgressStatusEnum.DUE_TODAY]: "Due today",
  [ResearchClientProgressStatusEnum.OVERDUE]: "Overdue",
  [ResearchClientProgressStatusEnum.COMPLETE]: "Complete",
};

export const RESEARCH_STAGE_POSITIONS: Record<
  ResearchStageEnum,
  { column: number; row: number }
> = {
  [ResearchStageEnum.INTAKE_QUEUE]: { column: 1, row: 1 },
  [ResearchStageEnum.ABOVE_BOARD_CONVERSATION]: { column: 2, row: 1 },
  [ResearchStageEnum.SHOP_QUEUE]: { column: 2, row: 2 },
  [ResearchStageEnum.SHOP_IN_PROCESS]: { column: 3, row: 2 },
  [ResearchStageEnum.RETRY_QUEUE]: { column: 3, row: 3 },
  [ResearchStageEnum.RETRY_IN_PROCESS]: { column: 3, row: 4 },
  [ResearchStageEnum.READY_FOR_REVIEW]: { column: 4, row: 1 },
  [ResearchStageEnum.REQUIRES_FIX]: { column: 4, row: 2 },
  [ResearchStageEnum.COMPLETED]: { column: 5, row: 1 },
};

export const compactResearchParams = <T extends object>(
  request: T
): Partial<T> =>
  Object.fromEntries(
    Object.entries(request as Record<string, unknown>).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  ) as Partial<T>;
